<template>
  <section>
    <gs-header title="Sửa địa chỉ"
      :breadcrumbs="[
        {title: 'Quản lý địa chỉ', route: {name: 'address'}}
      ]"
    >
    </gs-header>
    <div class="padding-all">
      <el-form :model="localAddress" :rules="rules" ref="editAddressForm" label-width="200px" label-position="top" @submit.prevent.native="validateBeforeSubmit('editAddressForm')">
        <el-row :gutter="20" class="remove-marrgin">
            <el-col :span="12">
              <el-form-item label="Tỉnh thành" prop="city_id">
                <el-select v-model="localAddress.city_id" filterable placeholder="Chọn tỉnh thành" @change="getDistricts" class="width-100">
                  <el-option
                    v-for="city in cities"
                    :key="city.id"
                    :label="city.name"
                    :value="city.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Quận huyện" prop="district_id">
                <el-select :disabled="!localAddress.city_id" v-model="localAddress.district_id" filterable placeholder="Chọn quận huyện" @change="getWards" class="width-100">
                  <el-option
                    v-for="district in districts"
                    :key="district.id"
                    :label="district.name"
                    :value="district.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Phường xã" prop="ward_id">
                <el-select :disabled="!localAddress.district_id" v-model="localAddress.ward_id" filterable placeholder="Chọn phường xã" class="width-100">
                  <el-option
                    v-for="ward in wards"
                    :key="ward.id"
                    :label="ward.name"
                    :value="ward.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Địa chỉ " prop="street">
                <el-input name="street" v-model="localAddress.street" placeholder="Địa chỉ"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

        <el-form-item>
          <button :disabled="submitting" class="ui blue basic small button" native-type="submit"><i class="fa fa-floppy-o"></i> Lưu lại</button>
        </el-form-item>
      </el-form>
    </div>
  </section>
</template>

<script>
import { editAddress, getAddress } from 'src/api/address'
import { head } from 'lodash'
import mixins from './mixins'
import GoogleMapsLoader from 'google-maps'
export default {

  name: 'EditAddress',
  mixins: [mixins],
  data () {
    return {}
  },
  methods: {
    validateBeforeSubmit () {
      this.submitting = true
      this.toggleLoadding()
      this.$refs.editAddressForm.validate(valid => {
        if (valid) {
          this.changedData = false
          editAddress(this.$route.params.id, this.localAddress).then(response => {
            switch (response.code) {
              case 200:
                this.submitting = false
                this.$store.dispatch('showNotify', {
                  title: 'Sửa thành công',
                  body: 'Sửa địa chỉ thành công'
                })
                this.reloadGsTableAfterRedirect({name: 'address'}, 'addresses')
                this.toggleLoadding(false)
                break
              case 422:
                this.submitting = false
                let er = response.data.errors
                let message = head(er[Object.keys(er)[0]])
                this.$store.dispatch('showNotify', {
                  title: 'Vui lòng kiểm tra thông tin cần nhập',
                  body: message,
                  type: 'warning'
                })
                this.toggleLoadding(false)
                break
              default:
                this.submitting = false
                this.$store.dispatch('showNotify', {
                  title: 'Vui lòng kiểm tra thông tin cần nhập',
                  body: 'Không tìm thấy tài nguyên',
                  type: 'warning'
                })
                this.toggleLoadding(false)
            }
          })
        } else {
          this.submitting = false
          this.$store.dispatch('toggleLoadding', false, {root: true})
          this.$store.dispatch('showNotify', {
            title: 'Vui lòng kiểm tra thông tin cần nhập',
            type: 'warning'
          })
          return false
        }
      })
    }
  },
  mounted () {
    this.loadAddress = true
    getAddress({id: this.$route.params.id}).then(response => {
      switch (response.code) {
        case 200:
          this.localAddress = response.data
          if (!response.data.ward_id) {
            this.localAddress.ward_id = undefined
          }
          setTimeout(() => {
            this.watching = true
          }, 100)
          this.$nextTick(() => {
            this.loadAddress = false
          })
          break
        case 404:
          this.$store.dispatch('showNotify', {
            title: 'Không tìm thấy tài nguyên',
            body: 'Vùng miền không tồn tại trên hệ thống',
            type: 'warning'
          }, {root: true})
          this.$route.push({name: 'address'})
          break
        default:
      }
    })

    try {
      setTimeout(() => {
        GoogleMapsLoader.KEY = process.env.GOOGLE_APP_KEY
        GoogleMapsLoader.LIBRARIES = ['places']
        GoogleMapsLoader.load((google) => {
          let street = document.getElementsByName('street')[0]
          let autocomplete = new google.maps.places.Autocomplete(street)
          autocomplete.setComponentRestrictions({'country': ['vn']})
          autocomplete.addListener('place_changed', () => {
            let places = autocomplete.getPlace()
            this.localAddress.street = places.name
            this.localAddress.latitude = places.geometry.location.lat()
            this.localAddress.longitude = places.geometry.location.lng()
          })
        })
      }, 3000)
    } catch (err) {
      console.log('connect google faild')
    }
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// EditAddress.vue?33f1f1bf